export default __webpack_public_path__ + "static/media/slider1.b47987c1.jpg";